import { useAuth } from "@/auth/AuthContext";
import React from "react";
import { Navigate } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

// only displays route if user is NOT logged in
export const AnonymousRoute: React.FC<Props> = ({ children }) => {
  const { user } = useAuth();

  return user ? <Navigate to="/home" /> : <>{children}</>;
};
